export const UNTAGGED_ID = 0;

const UntaggedId = Object.freeze({
  UNTAGGED_ID,
});

export default UntaggedId;
